import React, { useState } from 'react';
import { Search, Calendar, Users, Filter, ArrowRight, Plane, Clock, DollarSign, Hotel, Car, MapPin, Star, Wifi, Coffee, Dumbbell, CheckCircle, AlertTriangle, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
export function BookingPage() {
  const {
    submitBooking
  } = useAppContext();
  const [activeTab, setActiveTab] = useState<'flights' | 'hotels' | 'cars'>('flights');
  const [tripType, setTripType] = useState('round-trip');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSelect = (item: any) => {
    setSelectedBooking(item);
    setShowConfirmation(true);
  };
  const handleSubmitBooking = () => {
    submitBooking(selectedBooking);
    setShowConfirmation(false);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  };
  const flights = [{
    id: 1,
    type: 'flight',
    airline: 'United Airlines',
    logo: 'UA',
    departure: '08:00 AM',
    arrival: '11:30 AM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 450,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 2,
    type: 'flight',
    airline: 'Delta',
    logo: 'DL',
    departure: '09:15 AM',
    arrival: '01:45 PM',
    duration: '6h 30m',
    stops: '1 Stop',
    price: 380,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 3,
    type: 'flight',
    airline: 'American Airlines',
    logo: 'AA',
    departure: '10:30 AM',
    arrival: '02:00 PM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 490,
    class: 'Economy',
    policy: 'compliant'
  }, {
    id: 4,
    type: 'flight',
    airline: 'United Airlines',
    logo: 'UA',
    departure: '02:00 PM',
    arrival: '05:30 PM',
    duration: '5h 30m',
    stops: 'Non-stop',
    price: 520,
    class: 'Business',
    policy: 'violation'
  }];
  const hotels = [{
    id: 101,
    type: 'hotel',
    name: 'Marriott Union Square',
    rating: 4,
    price: 280,
    distance: '0.3 mi',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant',
    amenities: ['wifi', 'breakfast', 'gym']
  }, {
    id: 102,
    type: 'hotel',
    name: 'Hilton Financial District',
    rating: 4,
    price: 310,
    distance: '0.8 mi',
    image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=300&q=80',
    policy: 'violation',
    amenities: ['wifi', 'gym']
  }, {
    id: 103,
    type: 'hotel',
    name: 'Holiday Inn Civic Center',
    rating: 3,
    price: 195,
    distance: '1.2 mi',
    image: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant',
    amenities: ['wifi', 'breakfast']
  }, {
    id: 104,
    type: 'hotel',
    name: 'The Ritz-Carlton',
    rating: 5,
    price: 520,
    distance: '0.5 mi',
    image: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=300&q=80',
    policy: 'violation',
    amenities: ['wifi', 'breakfast', 'gym', 'pool']
  }];
  const cars = [{
    id: 201,
    type: 'car',
    category: 'Economy',
    model: 'Toyota Corolla',
    price: 45,
    vendor: 'Hertz',
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 202,
    type: 'car',
    category: 'Compact',
    model: 'Honda Civic',
    price: 52,
    vendor: 'Enterprise',
    image: 'https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 203,
    type: 'car',
    category: 'Midsize',
    model: 'Toyota Camry',
    price: 68,
    vendor: 'Avis',
    image: 'https://images.unsplash.com/photo-1619682817481-e994891cd1f5?auto=format&fit=crop&w=300&q=80',
    policy: 'compliant'
  }, {
    id: 204,
    type: 'car',
    category: 'SUV',
    model: 'Ford Explorer',
    price: 95,
    vendor: 'National',
    image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=300&q=80',
    policy: 'violation'
  }];
  return <div className="space-y-6 relative" data-id="element-294">
      {showSuccess && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-295">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-296">
            <CheckCircle className="h-5 w-5 text-emerald-600" data-id="element-297" />
            <div data-id="element-298">
              <p className="font-medium" data-id="element-299">Booking submitted for approval!</p>
              <Link to="/approvals" className="text-sm text-emerald-700 underline hover:text-emerald-900" data-id="element-300">
                View in Approvals
              </Link>
            </div>
            <button onClick={() => setShowSuccess(false)} className="ml-2 text-emerald-500 hover:text-emerald-700" data-id="element-301">
              <X className="h-4 w-4" data-id="element-302" />
            </button>
          </div>
        </div>}

      <div className="flex items-center justify-between" data-id="element-303">
        <h2 className="text-2xl font-bold text-slate-800" data-id="element-304">Book Travel</h2>
        <div className="flex gap-2" data-id="element-305">
          <button className="rounded-lg bg-white border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-306">
            Saved Searches
          </button>
        </div>
      </div>

      {/* Main Tabs */}
      <div className="flex gap-4 border-b border-slate-200" data-id="element-307">
        <button onClick={() => setActiveTab('flights')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'flights' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-308">
          <Plane className="h-4 w-4" data-id="element-309" /> Flights
        </button>
        <button onClick={() => setActiveTab('hotels')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'hotels' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-310">
          <Hotel className="h-4 w-4" data-id="element-311" /> Hotels
        </button>
        <button onClick={() => setActiveTab('cars')} className={`pb-3 px-4 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${activeTab === 'cars' ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-312">
          <Car className="h-4 w-4" data-id="element-313" /> Car Rental
        </button>
      </div>

      {/* Search Forms */}
      <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-314">
        {activeTab === 'flights' && <>
            <div className="mb-6 flex gap-6 border-b border-slate-200 pb-4" data-id="element-315">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-316">
                <input type="radio" name="tripType" checked={tripType === 'round-trip'} onChange={() => setTripType('round-trip')} className="text-blue-600 focus:ring-blue-500" data-id="element-317" />
                <span className="text-sm font-medium text-slate-700" data-id="element-318">
                  Round Trip
                </span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-319">
                <input type="radio" name="tripType" checked={tripType === 'one-way'} onChange={() => setTripType('one-way')} className="text-blue-600 focus:ring-blue-500" data-id="element-320" />
                <span className="text-sm font-medium text-slate-700" data-id="element-321">
                  One Way
                </span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-322">
                <input type="radio" name="tripType" checked={tripType === 'multi-city'} onChange={() => setTripType('multi-city')} className="text-blue-600 focus:ring-blue-500" data-id="element-323" />
                <span className="text-sm font-medium text-slate-700" data-id="element-324">
                  Multi-City
                </span>
              </label>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-325">
              <div className="md:col-span-3" data-id="element-326">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-327">
                  From
                </label>
                <div className="relative" data-id="element-328">
                  <Plane className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-329" />
                  <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Origin" defaultValue="New York (JFK)" data-id="element-330" />
                </div>
              </div>
              <div className="md:col-span-3" data-id="element-331">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-332">
                  To
                </label>
                <div className="relative" data-id="element-333">
                  <Plane className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 transform rotate-90" data-id="element-334" />
                  <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900 focus:border-blue-500 focus:ring-blue-500" placeholder="Destination" defaultValue="London (LHR)" data-id="element-335" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-336">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-337">
                  Departure
                </label>
                <div className="relative" data-id="element-338">
                  <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-339" />
                  <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-340" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-341">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-342">
                  Return
                </label>
                <div className="relative" data-id="element-343">
                  <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-344" />
                  <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-345" />
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-346">
                <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-347">
                  Travelers
                </label>
                <div className="relative" data-id="element-348">
                  <Users className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-349" />
                  <select className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-350">
                    <option data-id="element-351">1 Adult</option>
                    <option data-id="element-352">2 Adults</option>
                  </select>
                </div>
              </div>
            </div>
          </>}

        {activeTab === 'hotels' && <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-353">
            <div className="md:col-span-4" data-id="element-354">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-355">
                Destination
              </label>
              <div className="relative" data-id="element-356">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-357" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" placeholder="City, Hotel, or Address" defaultValue="San Francisco, CA" data-id="element-358" />
              </div>
            </div>
            <div className="md:col-span-3" data-id="element-359">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-360">
                Check-in
              </label>
              <div className="relative" data-id="element-361">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-362" />
                <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-363" />
              </div>
            </div>
            <div className="md:col-span-3" data-id="element-364">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-365">
                Check-out
              </label>
              <div className="relative" data-id="element-366">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-367" />
                <input type="date" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-368" />
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-369">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-370">
                Guests
              </label>
              <div className="relative" data-id="element-371">
                <Users className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-372" />
                <select className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-373">
                  <option data-id="element-374">1 Room, 1 Guest</option>
                  <option data-id="element-375">1 Room, 2 Guests</option>
                </select>
              </div>
            </div>
          </div>}

        {activeTab === 'cars' && <div className="grid grid-cols-1 gap-4 md:grid-cols-12" data-id="element-376">
            <div className="md:col-span-4" data-id="element-377">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-378">
                Pickup Location
              </label>
              <div className="relative" data-id="element-379">
                <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-380" />
                <input type="text" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" placeholder="Airport or City" defaultValue="SFO Airport" data-id="element-381" />
              </div>
            </div>
            <div className="md:col-span-4" data-id="element-382">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-383">
                Pickup Date & Time
              </label>
              <div className="relative" data-id="element-384">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-385" />
                <input type="datetime-local" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-386" />
              </div>
            </div>
            <div className="md:col-span-4" data-id="element-387">
              <label className="mb-1.5 block text-xs font-medium text-slate-500 uppercase" data-id="element-388">
                Return Date & Time
              </label>
              <div className="relative" data-id="element-389">
                <Calendar className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-390" />
                <input type="datetime-local" className="block w-full rounded-lg border border-slate-300 bg-slate-50 p-2.5 pl-10 text-slate-900" data-id="element-391" />
              </div>
            </div>
          </div>}

        <div className="mt-6 flex justify-end" data-id="element-392">
          <button className="flex items-center rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-393">
            <Search className="mr-2 h-4 w-4" data-id="element-394" />
            Search{' '}
            {activeTab === 'flights' ? 'Flights' : activeTab === 'hotels' ? 'Hotels' : 'Cars'}
          </button>
        </div>
      </div>

      {/* Results */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-4" data-id="element-395">
        {/* Sidebar Filters (Simplified for demo) */}
        <div className="space-y-6 lg:col-span-1" data-id="element-396">
          <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-397">
            <div className="mb-4 flex items-center justify-between" data-id="element-398">
              <h3 className="font-semibold text-slate-800" data-id="element-399">Filters</h3>
              <button className="text-xs text-blue-600 hover:underline" data-id="element-400">
                Reset
              </button>
            </div>
            <div className="space-y-4" data-id="element-401">
              <div data-id="element-402">
                <h4 className="mb-2 text-sm font-medium text-slate-700" data-id="element-403">
                  Price Range
                </h4>
                <input type="range" className="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer" data-id="element-404" />
              </div>
              <div className="border-t border-slate-200 pt-4" data-id="element-405">
                <h4 className="mb-2 text-sm font-medium text-slate-700" data-id="element-406">
                  Policy
                </h4>
                <label className="flex items-center" data-id="element-407">
                  <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-blue-600" defaultChecked data-id="element-408" />
                  <span className="ml-2 text-sm text-slate-600" data-id="element-409">
                    Within Policy Only
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Results List */}
        <div className="lg:col-span-3 space-y-4" data-id="element-410">
          {activeTab === 'flights' && flights.map(flight => <div key={flight.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-411">
                <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-412">
                  <div className="flex items-center gap-4 sm:w-1/4" data-id="element-413">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-slate-100 font-bold text-slate-600" data-id="element-414">
                      {flight.logo}
                    </div>
                    <div data-id="element-415">
                      <h4 className="font-semibold text-slate-900" data-id="element-416">
                        {flight.airline}
                      </h4>
                      <span className="text-xs text-slate-500" data-id="element-417">
                        {flight.class}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-1 items-center justify-center gap-4 sm:gap-8" data-id="element-418">
                    <div className="text-center" data-id="element-419">
                      <p className="text-lg font-bold text-slate-900" data-id="element-420">
                        {flight.departure}
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-421">JFK</p>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-422">
                      <p className="mb-1 text-xs text-slate-500" data-id="element-423">
                        {flight.duration}
                      </p>
                      <div className="flex w-24 items-center" data-id="element-424">
                        <div className="h-px w-full bg-slate-300" data-id="element-425"></div>
                        <Plane className="mx-1 h-3 w-3 text-slate-400" data-id="element-426" />
                        <div className="h-px w-full bg-slate-300" data-id="element-427"></div>
                      </div>
                      <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-428">
                        {flight.stops}
                      </p>
                    </div>
                    <div className="text-center" data-id="element-429">
                      <p className="text-lg font-bold text-slate-900" data-id="element-430">
                        {flight.arrival}
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-431">LHR</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between gap-4 border-t border-slate-100 pt-4 sm:w-1/4 sm:flex-col sm:border-l sm:border-t-0 sm:pl-6 sm:pt-0" data-id="element-432">
                    <div className="text-right sm:text-center" data-id="element-433">
                      <p className="text-2xl font-bold text-slate-900" data-id="element-434">
                        ${flight.price}
                      </p>
                      {flight.policy === 'violation' && <span className="text-xs text-amber-600 font-medium" data-id="element-435">
                          Exceeds Cap
                        </span>}
                    </div>
                    <button onClick={() => handleSelect(flight)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 sm:w-full" data-id="element-436">
                      Select
                    </button>
                  </div>
                </div>
              </div>)}

          {activeTab === 'hotels' && hotels.map(hotel => <div key={hotel.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-437">
                <div className="flex flex-col sm:flex-row gap-6" data-id="element-438">
                  <div className="h-32 w-full sm:w-48 rounded-lg bg-slate-200 bg-cover bg-center flex-shrink-0" style={{
              backgroundImage: `url(${hotel.image})`
            }} data-id="element-439"></div>
                  <div className="flex-1 flex flex-col justify-between" data-id="element-440">
                    <div data-id="element-441">
                      <div className="flex justify-between items-start" data-id="element-442">
                        <div data-id="element-443">
                          <h4 className="font-bold text-lg text-slate-900" data-id="element-444">
                            {hotel.name}
                          </h4>
                          <div className="flex items-center gap-1 text-amber-400 text-sm" data-id="element-445">
                            {[...Array(hotel.rating)].map((_, i) => <Star key={i} className="h-3 w-3 fill-current" data-id="element-446" />)}
                          </div>
                          <p className="text-sm text-slate-500 mt-1" data-id="element-447">
                            {hotel.distance} from venue
                          </p>
                        </div>
                        <div className="text-right" data-id="element-448">
                          <p className="text-2xl font-bold text-slate-900" data-id="element-449">
                            ${hotel.price}
                          </p>
                          <p className="text-xs text-slate-500" data-id="element-450">per night</p>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3" data-id="element-451">
                        {hotel.amenities.includes('wifi') && <Wifi className="h-4 w-4 text-slate-400" data-id="element-452" />}
                        {hotel.amenities.includes('breakfast') && <Coffee className="h-4 w-4 text-slate-400" data-id="element-453" />}
                        {hotel.amenities.includes('gym') && <Dumbbell className="h-4 w-4 text-slate-400" data-id="element-454" />}
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100" data-id="element-455">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${hotel.policy === 'compliant' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-456">
                        {hotel.policy === 'compliant' ? 'Within Policy' : 'Exceeds Cap'}
                      </span>
                      <button onClick={() => handleSelect(hotel)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700" data-id="element-457">
                        Select Room
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}

          {activeTab === 'cars' && cars.map(car => <div key={car.id} className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-blue-300 hover:shadow-md" data-id="element-458">
                <div className="flex flex-col sm:flex-row gap-6 items-center" data-id="element-459">
                  <div className="h-24 w-full sm:w-40 rounded-lg bg-slate-100 bg-cover bg-center flex-shrink-0" style={{
              backgroundImage: `url(${car.image})`
            }} data-id="element-460"></div>
                  <div className="flex-1 w-full" data-id="element-461">
                    <div className="flex justify-between items-start" data-id="element-462">
                      <div data-id="element-463">
                        <p className="text-xs font-bold text-slate-500 uppercase tracking-wide" data-id="element-464">
                          {car.category}
                        </p>
                        <h4 className="font-bold text-lg text-slate-900" data-id="element-465">
                          {car.model}
                        </h4>
                        <p className="text-sm text-slate-500" data-id="element-466">
                          Provided by {car.vendor}
                        </p>
                      </div>
                      <div className="text-right" data-id="element-467">
                        <p className="text-2xl font-bold text-slate-900" data-id="element-468">
                          ${car.price}
                        </p>
                        <p className="text-xs text-slate-500" data-id="element-469">per day</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100" data-id="element-470">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${car.policy === 'compliant' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-471">
                        {car.policy === 'compliant' ? 'Within Policy' : 'Exceeds Cap'}
                      </span>
                      <button onClick={() => handleSelect(car)} className="rounded-lg bg-blue-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700" data-id="element-472">
                        Select Car
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
        </div>
      </div>

      {/* Booking Confirmation Modal */}
      {showConfirmation && selectedBooking && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm" data-id="element-473">
          <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl animate-in fade-in zoom-in-95 duration-200" data-id="element-474">
            <div className="flex items-center justify-between mb-6" data-id="element-475">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-476">
                Confirm Booking
              </h3>
              <button onClick={() => setShowConfirmation(false)} className="rounded-full p-1 hover:bg-slate-100" data-id="element-477">
                <X className="h-5 w-5 text-slate-500" data-id="element-478" />
              </button>
            </div>

            <div className="bg-slate-50 rounded-xl p-4 mb-6 border border-slate-200" data-id="element-479">
              <div className="flex gap-4" data-id="element-480">
                <div className="h-16 w-16 rounded-lg bg-white border border-slate-200 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-481">
                  {selectedBooking.image ? <img src={selectedBooking.image} alt="" className="h-full w-full object-cover" data-id="element-482" /> : <span className="font-bold text-slate-400" data-id="element-483">
                      {selectedBooking.logo || <Plane data-id="element-484" />}
                    </span>}
                </div>
                <div data-id="element-485">
                  <h4 className="font-bold text-slate-900" data-id="element-486">
                    {selectedBooking.name || selectedBooking.model || selectedBooking.airline}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-487">
                    {selectedBooking.description || selectedBooking.vendor || 'Standard Rate'}
                  </p>
                  <div className="mt-2 flex items-center gap-2" data-id="element-488">
                    {selectedBooking.policy === 'compliant' ? <span className="flex items-center text-xs font-medium text-emerald-700" data-id="element-489">
                        <CheckCircle className="h-3 w-3 mr-1" data-id="element-490" /> Within Policy
                      </span> : <span className="flex items-center text-xs font-medium text-amber-700" data-id="element-491">
                        <AlertTriangle className="h-3 w-3 mr-1" data-id="element-492" /> Requires
                        Approval
                      </span>}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center mb-8 pb-6 border-b border-slate-100" data-id="element-493">
              <span className="text-slate-600" data-id="element-494">Total Estimated Cost</span>
              <span className="text-2xl font-bold text-slate-900" data-id="element-495">
                ${selectedBooking.price}
              </span>
            </div>

            <div className="flex gap-3" data-id="element-496">
              <button onClick={() => setShowConfirmation(false)} className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-497">
                Cancel
              </button>
              <button onClick={handleSubmitBooking} className="flex-1 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-498">
                Submit for Approval
              </button>
            </div>
          </div>
        </div>}
    </div>;
}